// Fakta umum Tata Surya (untuk Home)
export const homeFacts = [
  "Tata surya terdiri dari delapan planet yang semuanya mengelilingi Matahari sebagai pusat gravitasinya.",
  "Matahari menyumbang lebih dari 99 persen massa tata surya sehingga pengaruh gravitasinya sangat dominan.",
  "Selain planet, tata surya juga dihuni oleh asteroid, komet, dan meteoroid yang terus bergerak di angkasa.",
  "Sabuk asteroid terletak di antara Mars dan Jupiter dan berisi jutaan batuan luar angkasa.",
  "Planet dalam memiliki permukaan berbatu, sedangkan planet luar sebagian besar tersusun dari gas dan es.",
  "Setiap planet memiliki waktu rotasi dan revolusi yang berbeda-beda.",
  "Hampir semua planet di tata surya memiliki satelit alami atau bulan.",
  "Uranus berputar dengan posisi miring ekstrem dibandingkan planet lainnya.",
  "Neptunus dikenal memiliki angin tercepat di tata surya.",
  "Tata surya diperkirakan terbentuk sekitar 4,6 miliar tahun lalu.",
  "Gaya gravitasi Matahari menjaga semua benda di tata surya tetap berada pada orbitnya.",
  "Jarak antar planet di tata surya sangat jauh dan diukur menggunakan satuan astronomi.",
  "Setiap planet memiliki karakteristik unik yang membedakannya satu sama lain.",
  "Eksplorasi tata surya dilakukan menggunakan teleskop, satelit, dan wahana antariksa.",
  "Ilmuwan terus mempelajari tata surya untuk memahami asal-usul alam semesta."
];

// Fakta cepat Matahari
export const sunFacts = [
  "Matahari adalah bintang di pusat tata surya yang dikelilingi oleh semua planet.",
  "Ukuran Matahari sangat besar, sekitar 1,3 juta Bumi bisa muat di dalamnya.",
  "Matahari memberikan cahaya dan panas yang membuat kehidupan di Bumi bisa ada.",
  "Permukaan Matahari sangat panas, suhunya bisa mencapai lebih dari 5.500 derajat Celsius.",
  "Matahari tersusun terutama dari gas hidrogen dan helium.",
  "Cahaya Matahari membutuhkan waktu sekitar 8 menit untuk sampai ke Bumi.",
  "Matahari sudah bersinar selama sekitar 4,6 miliar tahun.",
  "Tanpa Matahari, Bumi akan menjadi gelap dan sangat dingin.",
  "Matahari terus menghasilkan energi melalui proses yang disebut fusi nuklir.",
  "Matahari terlihat kecil dari Bumi, tetapi sebenarnya jauh lebih besar dari planet mana pun.",
  "Energi Matahari berasal dari penggabungan inti atom hidrogen di pusatnya.",
  "Ledakan kecil di permukaan Matahari disebut suar Matahari.",
  "Matahari memiliki siklus aktivitas yang berubah setiap sekitar 11 tahun.",
  "Gravitasi Matahari menjaga planet-planet tetap berada pada jalurnya.",
  "Tanpa energi Matahari, ekosistem di Bumi tidak dapat bertahan."
];

// Fakta cepat Planet Merkurius
export const mercuryFacts = [
  "Merkurius adalah planet terdekat dengan Matahari.",
  "Merkurius adalah planet terkecil di tata surya.",
  "Suhu di Merkurius bisa sangat panas di siang hari dan sangat dingin di malam hari.",
  "Merkurius tidak memiliki atmosfer tebal seperti Bumi.",
  "Satu tahun di Merkurius jauh lebih singkat daripada di Bumi.",
  "Permukaan Merkurius dipenuhi kawah akibat tumbukan meteor.",
  "Merkurius tidak memiliki bulan.",
  "Planet ini bergerak sangat cepat mengelilingi Matahari.",
  "Langit di Merkurius terlihat sangat gelap.",
  "Merkurius dinamai dari dewa pembawa pesan Romawi.",
  "Perbedaan suhu di Merkurius adalah yang paling ekstrem di tata surya.",
  "Merkurius hampir tidak memiliki udara untuk bernapas.",
  "Langit Merkurius tidak berwarna biru seperti di Bumi.",
  "Planet ini sering terkena radiasi Matahari secara langsung.",
  "Merkurius sulit diamati karena posisinya sangat dekat dengan Matahari."
];

// Fakta cepat Planet Venus
export const venusFacts = [
  "Venus sering disebut sebagai saudara kembar Bumi karena ukurannya hampir sama.",
  "Venus adalah planet terpanas di tata surya.",
  "Atmosfer Venus sangat tebal dan dipenuhi gas beracun.",
  "Satu hari di Venus lebih lama daripada satu tahunnya.",
  "Venus berputar ke arah yang berlawanan dari kebanyakan planet.",
  "Permukaan Venus dipenuhi gunung berapi.",
  "Venus tampak sangat terang jika dilihat dari Bumi.",
  "Planet ini sering disebut Bintang Kejora.",
  "Venus tidak memiliki bulan.",
  "Suhu di Venus cukup panas untuk melelehkan logam.",
  "Awan tebal Venus memantulkan cahaya Matahari dengan sangat kuat.",
  "Tekanan udara di Venus jauh lebih besar dibandingkan di Bumi.",
  "Permukaan Venus sulit dipelajari karena tertutup awan tebal.",
  "Venus tidak cocok untuk kehidupan seperti di Bumi.",
  "Planet ini menjadi contoh efek rumah kaca ekstrem."
];

// Fakta cepat Planet Bumi
export const earthFacts = [
  "Bumi adalah satu-satunya planet yang diketahui memiliki kehidupan.",
  "Sebagian besar permukaan Bumi ditutupi oleh air.",
  "Bumi memiliki atmosfer yang melindungi makhluk hidup.",
  "Bumi memiliki satu bulan alami.",
  "Satu hari di Bumi berlangsung selama 24 jam.",
  "Bumi berputar sambil mengelilingi Matahari.",
  "Suhu di Bumi cocok untuk kehidupan.",
  "Bumi memiliki medan magnet yang melindungi dari radiasi Matahari.",
  "Bumi berbentuk bulat seperti bola.",
  "Bumi disebut sebagai Planet Biru.",
  "Bumi memiliki keseimbangan suhu yang stabil karena atmosfernya.",
  "Air di Bumi dapat ditemukan dalam bentuk cair, padat, dan gas.",
  "Bumi memiliki lapisan ozon yang melindungi dari sinar berbahaya.",
  "Rotasi Bumi menyebabkan terjadinya siang dan malam.",
  "Bumi terus berubah karena aktivitas alam seperti gunung berapi dan gempa."
];

// Fakta cepat Planet Mars
export const marsFacts = [
  "Mars dikenal sebagai Planet Merah karena permukaannya dipenuhi debu besi yang teroksidasi.",
  "Suhu di Mars sangat dingin dan bisa turun hingga minus 60 derajat Celsius.",
  "Mars memiliki gunung tertinggi di tata surya bernama Olympus Mons.",
  "Satu hari di Mars hampir sama panjangnya dengan satu hari di Bumi.",
  "Mars memiliki dua bulan kecil bernama Phobos dan Deimos.",
  "Ilmuwan menemukan bukti bahwa Mars pernah memiliki air di masa lalu.",
  "Atmosfer Mars sangat tipis sehingga tidak bisa menahan panas dengan baik.",
  "Badai debu di Mars bisa menutupi hampir seluruh permukaan planet.",
  "Mars menjadi target utama eksplorasi karena berpotensi pernah mendukung kehidupan.",
  "Beberapa robot penjelajah NASA telah mendarat dan meneliti Mars.",
  "Langit Mars sering terlihat kemerahan karena debu halus di udaranya.",
  "Mars memiliki musim seperti Bumi meskipun lebih lama.",
  "Es dapat ditemukan di kutub Mars.",
  "Mars menjadi tujuan utama misi manusia di masa depan.",
  "Permukaan Mars terlihat mirip gurun berbatu."
];

// Fakta cepat Planet Jupiter
export const jupiterFacts = [
  "Jupiter adalah planet terbesar di tata surya dengan ukuran yang jauh melampaui planet lainnya.",
  "Jupiter memiliki badai raksasa bernama Bintik Merah Besar yang telah berlangsung selama ratusan tahun.",
  "Planet ini tersusun terutama dari gas hidrogen dan helium sehingga tidak memiliki permukaan padat.",
  "Jupiter memiliki banyak bulan yang mengorbit di sekelilingnya dalam sistem yang sangat kompleks.",
  "Gravitasi Jupiter sangat kuat dan memengaruhi pergerakan benda langit di sekitarnya.",
  "Satu hari di Jupiter berlangsung sangat singkat karena planet ini berputar dengan kecepatan tinggi.",
  "Jupiter memiliki cincin tipis yang sulit terlihat dibandingkan cincin Saturnus.",
  "Planet ini sering disebut sebagai pelindung Bumi karena gravitasinya dapat menarik asteroid berbahaya.",
  "Jupiter berputar sangat cepat sehingga bentuknya sedikit menggelembung di bagian tengah.",
  "Planet ini dinamai dari raja para dewa Romawi karena ukurannya yang sangat besar.",
  "Jupiter memiliki medan magnet paling kuat di antara semua planet.",
  "Beberapa bulan Jupiter, seperti Europa, diduga memiliki lautan di bawah permukaannya.",
  "Atmosfer Jupiter dipenuhi awan tebal dengan pola yang terus berubah.",
  "Jupiter dapat terlihat dari Bumi tanpa teleskop pada malam hari.",
  "Planet ini berperan penting dalam menjaga kestabilan tata surya."
];

// Fakta cepat Planet Saturnus
export const saturnFacts = [
  "Saturnus terkenal dengan cincin indahnya yang terlihat jelas dari kejauhan.",
  "Cincin Saturnus terbuat dari es dan batu yang mengorbit planet dalam jumlah sangat banyak.",
  "Saturnus adalah planet gas raksasa yang sebagian besar tersusun dari hidrogen dan helium.",
  "Saturnus memiliki banyak bulan dengan ukuran dan karakteristik yang berbeda-beda.",
  "Saturnus memiliki kepadatan yang rendah sehingga secara teori dapat mengapung di air raksasa.",
  "Satu hari di Saturnus berlangsung singkat karena rotasinya yang cepat.",
  "Planet ini sangat besar tetapi memiliki massa jenis yang relatif ringan.",
  "Angin di Saturnus bisa bertiup dengan kecepatan sangat tinggi.",
  "Saturnus berwarna kekuningan karena kandungan gas di atmosfernya.",
  "Planet ini dinamai dari dewa pertanian dalam mitologi Romawi.",
  "Salah satu bulan Saturnus, Titan, memiliki atmosfer tebal.",
  "Cincin Saturnus terbagi menjadi beberapa lapisan.",
  "Saturnus dapat diamati dengan teleskop kecil dari Bumi.",
  "Badai besar dapat muncul di atmosfer Saturnus.",
  "Saturnus membutuhkan waktu puluhan tahun untuk mengelilingi Matahari."
];

// Fakta cepat Planet Uranus
export const uranusFacts = [
  "Uranus berputar dengan posisi miring ke samping sehingga tampak seperti menggelinding.",
  "Planet ini berwarna biru kehijauan karena kandungan gas metana di atmosfernya.",
  "Uranus adalah planet gas es yang memiliki suhu sangat rendah.",
  "Uranus termasuk planet paling dingin di tata surya.",
  "Planet ini memiliki cincin tipis yang sulit terlihat.",
  "Uranus memiliki banyak bulan yang dinamai dari tokoh sastra.",
  "Satu tahun di Uranus berlangsung sangat lama karena jaraknya yang jauh dari Matahari.",
  "Uranus ditemukan dengan bantuan teleskop pada abad ke-18.",
  "Planet ini dinamai dari dewa langit dalam mitologi Yunani.",
  "Uranus tampak redup jika dilihat dari Bumi tanpa alat bantu.",
  "Kemiringan Uranus menyebabkan musim yang sangat ekstrem.",
  "Satu musim di Uranus bisa berlangsung puluhan tahun.",
  "Atmosfer Uranus dipenuhi awan es.",
  "Uranus jarang dikunjungi wahana antariksa.",
  "Planet ini memiliki medan magnet yang tidak biasa."
];

// Fakta cepat Planet Neptunus
export const neptuneFacts = [
  "Neptunus adalah planet terjauh dari Matahari dalam tata surya.",
  "Neptunus berwarna biru cerah karena kandungan gas metana di atmosfernya.",
  "Angin di Neptunus adalah yang tercepat di tata surya.",
  "Neptunus adalah planet es raksasa dengan suhu yang sangat dingin.",
  "Planet ini menerima sangat sedikit panas dari Matahari.",
  "Neptunus memiliki cincin tipis yang mengelilinginya.",
  "Neptunus memiliki banyak bulan yang mengorbitnya.",
  "Satu tahun di Neptunus berlangsung sangat lama karena orbitnya yang luas.",
  "Planet ini sulit dilihat tanpa teleskop karena jaraknya yang jauh.",
  "Neptunus dinamai dari dewa laut dalam mitologi Romawi.",
  "Badai besar sering muncul di atmosfer Neptunus.",
  "Warna Neptunus tampak lebih gelap dibanding Uranus.",
  "Neptunus hanya pernah dikunjungi satu wahana antariksa.",
  "Gravitasi Neptunus sangat kuat.",
  "Planet ini memiliki cuaca yang sangat ekstrem."
];

// Fakta cepat Planet Pluto
export const plutoFacts = [
  "Pluto disebut sebagai planet katai karena ukurannya yang kecil.",
  "Pluto sangat kecil dan memiliki suhu yang sangat dingin.",
  "Pluto berada di wilayah Sabuk Kuiper yang dipenuhi benda es.",
  "Pluto memiliki orbit yang unik dan tidak beraturan.",
  "Pluto memiliki beberapa bulan yang mengorbitnya.",
  "Permukaan Pluto tertutup es dan pegunungan beku.",
  "Pluto ditemukan pada tahun 1930 oleh seorang astronom.",
  "Satu tahun di Pluto berlangsung sangat panjang.",
  "Pluto berada sangat jauh dari Matahari.",
  "Pluto dulu dianggap sebagai planet kesembilan.",
  "Pluto memiliki atmosfer tipis yang bisa membeku.",
  "Permukaan Pluto sangat beragam meskipun ukurannya kecil.",
  "Pluto membantu ilmuwan mempelajari Sabuk Kuiper.",
  "Cahaya Matahari sangat redup di Pluto.",
  "Pluto menjadi objek penelitian penting hingga kini."
];

// Fakta cepat Bulan
export const moonFacts = [
  "Bulan adalah satelit alami Bumi yang selalu mengorbit planet kita.",
  "Bulan memantulkan cahaya Matahari sehingga terlihat bersinar di malam hari.",
  "Bulan tidak memiliki cahaya sendiri dan hanya memantulkan cahaya.",
  "Permukaan Bulan dipenuhi kawah akibat tumbukan meteor.",
  "Bulan memengaruhi pasang surut air laut di Bumi.",
  "Satu bulan di Bulan berlangsung sekitar 29 hari.",
  "Bulan tidak memiliki atmosfer tebal seperti Bumi.",
  "Bulan selalu menghadap sisi yang sama ke Bumi.",
  "Manusia pertama kali mendarat di Bulan pada tahun 1969.",
  "Bulan tampak berubah bentuk karena fase-fasenya.",
  "Suhu di Bulan bisa sangat panas dan sangat dingin.",
  "Tidak ada air cair di permukaan Bulan.",
  "Bulan membantu menjaga kestabilan rotasi Bumi.",
  "Langit di Bulan selalu tampak gelap.",
  "Bulan menjadi objek penelitian luar angkasa hingga sekarang."
];


//Fakta cepat Tata Surya 2 (untuk funfact)
export const solarSystemFunFacts = [
  "Gravitasi adalah gaya tak terlihat yang membuat planet tetap mengorbit Matahari dan mencegahnya terlempar ke luar angkasa.",
  "Bulan memengaruhi pasang dan surut air laut di Bumi melalui gaya gravitasinya.",
  "Rotasi Bumi adalah penyebab terjadinya siang dan malam yang kita alami setiap hari.",
  "Revolusi Bumi mengelilingi Matahari menyebabkan terjadinya pergantian musim.",
  "Asteroid adalah sisa-sisa pembentukan tata surya yang tidak pernah menjadi planet.",
  "Beberapa asteroid memiliki bentuk tidak beraturan seperti kentang raksasa di luar angkasa.",
  "Meteor yang terlihat sebagai bintang jatuh sebenarnya adalah batu kecil yang terbakar di atmosfer Bumi.",
  "Jika tidak ada Bulan, rotasi Bumi akan menjadi tidak stabil dan iklim bisa berubah drastis.",
  "Gravitasi di Bulan hanya sekitar seperenam gravitasi Bumi, sehingga manusia bisa melompat lebih tinggi.",
  "Gerhana Matahari terjadi ketika Bulan berada tepat di antara Bumi dan Matahari.",
  "Gerhana Bulan terjadi saat bayangan Bumi menutupi permukaan Bulan.",
  "Orbit planet tidak benar-benar berbentuk lingkaran, melainkan sedikit lonjong atau elips.",
  "Planet tidak saling bertabrakan karena masing-masing memiliki jalur orbit yang stabil.",
  "Beberapa komet memiliki ekor panjang yang selalu menjauhi Matahari karena dorongan angin surya.",
  "Ilmuwan mempelajari tata surya untuk memahami bagaimana Bumi dan kehidupan bisa terbentuk."
];